import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-jsx'

export const prismJs = (code, language) => highlight(code, languages.js);
export const prismJsx = (code, language) => highlight(code, languages.jsx);
export const prismHtml = (code, language) => highlight(code, languages.html);
export const prismCss = (code, language) => highlight(code, languages.css);



// WEBPACK FOOTER //
// ./src/utils/prism.js